import React                   from 'react'
import { connect }             from 'react-redux'
import i18n from '../../i18n';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import {mapDispatchToProps} from "../mapDispatchToProps"
import Formsy from 'formsy-react';
import Input from '../forms/Input'
import TagItem from './tags/TagItem'
import withBaseComponent from '../withBaseComponent';
import EmptyTag from './tags/EmptyTag'
import { MAX_TAGS_AMOUNT } from '../../constants'
import NoticeModal from '../common/NoticeModal'
import { trackingEvent } from "./layouts/GoogleAnalytics.js"

class Tags extends withBaseComponent(React.Component) {
  constructor(props) {
    super(props)

    this.onSubmit = this.onSubmit.bind(this)
    this.clickNewHandler = this.clickNewHandler.bind(this)
  }

  onSubmit(model) {
    if (this.hasError()) {
      this.showErrors(model, this.refs.form.updateInputsWithError)
      return
    }

    this.props.userActions.addTag({tag: model}).then(res => {
      this.toggleModal()
      return res
    })
  }

  componentWillMount() {
    this.props.userActions.tags()
  }

  renderTagList() {
    if(!this.props.tags.length)
      return <EmptyTag />

    return (
      <div className="col-sm-12 content-body">
        <table className="table">
          <thead>
          <tr>
            <th scope="col" className="w-40 text-sm-left">{i18n.t('tag.list.name')}</th>
            <th scope="col" className="w-15 text-sm-left">{i18n.t('tag.list.used_number')} </th>
            <th scope="col" className="w-45"></th>
          </tr>
          </thead>
          <tbody>
          {this.props.tags.map(tag => {
            return <TagItem key={tag.id} item={tag} userActions={this.props.userActions}/>
          })}
          </tbody>
        </table>
      </div>
    )
  }

  clickNewHandler() {
    this.props.userActions.amountTags().then(() => {
      if(this.props.tagsAmount >= MAX_TAGS_AMOUNT){
        this.toggleModal('limitTagNotice')
      } else {
        this.toggleModal('createTagForm')
      }
    })
  }

  trackingNewHandler() {
    trackingEvent("Tag", "新規追加")
    this.clickNewHandler()
  }

  render() {
    return (
      <div className="tag-container small-container">
        <div className="row no-gutters">
          <div className="col-sm-12 title">
            <div className="float-left">{i18n.t("tag.title.list")}</div>
            <div className="float-right">
              <button type="button" className="btn mfc-btn-blue medium" onClick={ () => this.trackingNewHandler()} >{i18n.t("tag.button.new")}</button>
            </div>
          </div>
        </div>
        <div className="row">
        {this.renderTagList()}
        </div>

        <Modal isOpen={this.state.currentModal === 'createTagForm'} className={this.props.className} centered={true}>
          <Formsy onChange={this.showErrors} ref="form" onSubmit={(model) => this.onSubmit(model)} onValid={this.enableButton} onInvalid={this.disableButton}>
            <ModalHeader toggle={this.toggleModal}>{i18n.t('tag.title.new')}</ModalHeader>
            <ModalBody>
              <div className="form-group">
                <label>{i18n.t('tag.form.name')}</label>
                <Input name="name" className=""
                  placeholder={i18n.t('tag.form.name_placeholder')}
                  validations="maxLength:20"
                  validationError={i18n.t('validations.tags.name')}
                  isDefaultRequiredValue={false}
                  required />
              </div>
            </ModalBody>
            <ModalFooter>
              <Button onClick={this.toggleModal} className="btn mfc-btn-gray medium">{i18n.t('common.cancel')}</Button>
              <button className="btn mfc-btn-blue medium" type="submit">
                {i18n.t('common.save')}
              </button>
            </ModalFooter>
          </Formsy>
        </Modal>
        <NoticeModal
          isOpen={this.state.currentModal === 'limitTagNotice' }
          toggle={this.toggleModal}
          title={i18n.t("tag.limit_max_modal.title")}
          body={i18n.t("tag.limit_max_modal.message", {amount: MAX_TAGS_AMOUNT})}
        />
      </div>
    )
  }
}

function mapStateToProps(state) {
  return {
    tags: state.user.get('tags') || [],
    globalErrors: state.global.get('errors') || null,
    tagsAmount: state.user.get('tagsAmount')
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Tags)
